import React from "react";
import ReactDOM from "react-dom/client";
import "@engie-group/fluid-design-system-react/css";
import "./index.css";
import App from "./App";
import { initTheme } from "./features/theme/theme";

initTheme();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
